// https://github.com/getslick/api.transaction/blob/staging/docs/Vouchers.md#create-sell-voucher

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import feBookingCleanUpNewClient from 'actions/booking/feBookingCleanUpNewClient.action';
import VoucherViewDropdown from 'components/form/VoucherViewDropdown.component';
import AlertPanel from 'components/generic/AlertPanel.component';
import Icon from 'components/generic/Icon.component';
import CurrencySign from 'components/price/CurrencySign.component';
import DELAY from 'constants/delay.const';
import SYMBOLS from 'constants/form/symbols.const';
import S from 'constants/string.const';
import VOUCHER_CODE_TYPE from 'constants/voucherCodeType.const';
import { withTranslation } from 'providers/GILT.provider';
import { selectCashup } from 'selectors/cashup.selectors';
import { selectCurrentSalonCalendarMode, selectCurrentSalonClientsArray, selectCurrentSalonId, selectCurrentSalonPosFlow, selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import delayed from 'utils/functions/delayed.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import asObject from 'utils/objects/asObject.util';
import isEmptyString from 'utils/predicates/string/isEmptyString.util';
import C from 'utils/values/constant.util';

import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import { checkVoucher, createVoucher, generateVoucherNumber, getAllVoucher } from 'cashup/actions';
import RadioForm from 'onboarding/common/RadioForm';

import 'react-dropdown/style.css';
import 'styles/voucher/voucher.scss';
import CN from './VoucherView.module.scss';

const DEFAULT_MONTHS_VALUE = '12';

const MONTHS = C([
  { id: 1, value: '6' },
  { id: 2, value: '8' },
  { id: 3, value: '12' },
  { id: 4, value: '24' },
]);

class VoucherView extends React.Component {
  constructor(props) {
    super(props);
    this.customCodeRef = React.createRef();
    this.state = {
      amount: '',
      customCode: '',
      customMonth: '',
      errorCustomMsg: false,
      errorMonth: '',
      errorPrice: '',
      errorSourceMsg: '',
      errorInvalidChar: false,
      isDropdownMonths: false,
      isDropdownOpen: false,
      isDropdownOpen2: false,
      renderDropdownStylists: false,
      purchaser: '',
      purchaserList: null,
      stylist: null,
      recipient: '',
      recipientList: null,
      searchTerm: '',
      searchTerm2: '',
      searchStylistTerm: '',
      value: VOUCHER_CODE_TYPE.auto,
      voucherNumberGenerated: '',
      voucherObj: null,
    };
  }

  componentDidMount() {
    this.props.generateVoucherNumber(this.props.salonId);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location, voucherNumberGenerated, newClient } = nextProps;
    const { value, customCode, recipient, purchaser, voucherObj } = this.state;

    if (fromAnyToBool(voucherNumberGenerated)) {
      let voucher = voucherObj || {};

      if (value === VOUCHER_CODE_TYPE.auto) {
        voucher = { ...voucher, number: voucherNumberGenerated.number };

        this.setState({
          errorCustomMsg: false,
        });
      } else {
        voucher = { ...voucher, number: customCode || '' };
      }

      this.setState({
        voucherNumberGenerated: voucherNumberGenerated ? voucherNumberGenerated.number : '',
        errorCustomMsg: false,
        voucherObj: voucher,
      });
    }

    if (fromAnyToBool(location.state)) {
      if (location.state.newClientName && location.state.isRecipient && !recipient && newClient && !voucherObj.purchased_for_clientId) {
        this.setState({
          recipient: location.state.newClientName,
          voucherObj: { ...voucherObj, purchased_for_clientId: newClient.id },
        });
      }

      if (location.state.newClientName && location.state.isPurchaser && !purchaser && newClient && !voucherObj.purchased_by_clientId) {
        this.setState({
          purchaser: location.state.newClientName,
          voucherObj: { ...voucherObj, purchased_by_clientId: newClient.id },
        });
      }

      if (location.state.newClientName && location.state.isPurchaser && !purchaser && newClient && !voucherObj.sold_by_stylistId) {
        this.setState({
          purchaser: location.state.newClientName,
          voucherObj: { ...voucherObj, sold_by_stylistId: newClient.id },
        });
      }
    }
  }

  componentWillUnmount() {
    this.setState({ customCode: '', voucherNumberGenerated: '' });
  }

  onChangeRadioCode = (event) => {
    const { voucherNumberGenerated } = this.props;
    const { voucherObj } = this.state;

    this.setState({
      value: event.target.value,
    });

    if (event.target.value === VOUCHER_CODE_TYPE.custom) {
      this.customCodeRef && this.customCodeRef.current && this.customCodeRef.current.focus();
    } else {
      this.setState({
        customCode: '',
        errorCustomMsg: false,
        voucherObj: { ...voucherObj, number: voucherNumberGenerated.number },
      });
    }
  };

  onChangeCustomCode = (ev) => {
    const value = ev.target.value;
    const hasAmpersand = value.includes(SYMBOLS.amp);

    this.setState({
      customCode: value,
      value: VOUCHER_CODE_TYPE.custom,
      errorCustomMsg: false,
      errorInvalidChar: hasAmpersand,
    });
  };

  onBlurCustomCode = () => {
    const { checkVoucher, salonId } = this.props;
    const { customCode, errorInvalidChar } = this.state;

    if (errorInvalidChar) return;

    if (!isEmptyString(customCode)) {
      checkVoucher(salonId, customCode).then((result) => {
        if (result.is.ok) {
          void this.setState({ errorCustomMsg: true });
        }
      });
    }
  };

  onChangeMonth = (e) => {
    this.setState({ customMonth: e.target.value, isDropdownMonths: true });
  };

  onSelectMonth = (month) => {
    const regex = /^[1-9][0-9]?$|^100$/;
    if (regex.test(this.state.customMonth)) {
      this.setState({ customMonth: month, errorMonth: '' });
    } else {
      this.setState({ errorMonth: ' ' });
    }
    this.setState({
      customMonth: month,
      isDropdownMonths: false,
    });
  };

  onMonthBlur = ({ currentTarget, relatedTarget }) => {
    if (currentTarget.contains(relatedTarget)) return;

    // FIXME: this is wrong, remove the delayed and just use this.setState
    delayed(
      this.setState(() => ({ isDropdownMonths: false })),
      DELAY.attention,
    );
  };

  onRecipientBlur = ({ currentTarget, relatedTarget }) => {
    if (currentTarget.contains(relatedTarget)) return;

    // FIXME: this is wrong, remove the delayed and just use this.setState
    delayed(
      this.setState(() => ({ isDropdownOpen: false })),
      DELAY.attention,
    );
  };

  onPurchaserBlur = ({ currentTarget, relatedTarget }) => {
    if (currentTarget.contains(relatedTarget)) return;

    // FIXME: this is wrong, remove the delayed and just use this.setState
    delayed(this.setState({ isDropdownOpen2: false }), DELAY.attention);
  };

  validateVoucherPrice = (evt) => {
    this.setState({ amount: evt.target.value, errorPrice: '' });
  };

  validatePriceOnBlur = (evt) => {
    const regex = /^\d+({,\d})*(\.\d{1,2})?$/;
    if (regex.test(evt.target.value)) {
      this.setState({ amount: evt.target.value, errorPrice: '' });
      this.setState({ amount: parseFloat(this.state.amount).toFixed(2) });
    } else {
      this.setState({ errorPrice: this.props.t('scheduler.voucherView.voucherValueInputError.validPrice') });
    }
  };

  validateMonthOnBlur = (evt) => {
    const regex = /^(?:[1-9]|[1-4][0-9]|24)$/;
    if (regex.test(evt.target.value)) {
      this.setState({ customMonth: evt.target.value, errorMonth: '' });
      this.setState({ customMonth: this.state.customMonth });
    } else {
      this.setState({ errorMonth: this.props.t('scheduler.voucherView.expiresAfterInputError') });
    }
  };

  searchRecipient = (event) => {
    if (event.target.value.length > 1) {
      this.setState({
        searchTerm: event.target.value,
        recipient: '',
        isDropdownOpen: true,
      });
      const { clientList } = this.props;
      const recipientList = clientList.filter((e) => e.user_name.toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0);
      this.setState({ recipientList });
    } else {
      this.setState({
        searchTerm: event.target.value,
        recipient: '',
        isDropdownOpen: false,
      });
    }
    if (event.target.value === 'Add new client') {
      this.props.history.push(`${this.props.history.location.pathname}/create/new/client/new/`);
    }
  };

  selectRecipient = (client) => {
    this.setState({
      searchTerm: client.user_name,
      voucherObj: { ...this.state.voucherObj, purchased_for_clientId: client.id },
      isDropdownOpen: false,
    });
  };

  addNewClient = () => {
    let newPath = this.props.location.pathname;
    const pathArray = this.props.history.location.pathname.split('/');
    if (pathArray[3] === 'day') {
      newPath = pathArray.slice(0, 5).join('/');
    } else if (pathArray[3] === 'week') {
      newPath = pathArray.slice(0, 6).join('/');
    }

    this.props.history.push({
      pathname: `${newPath}/create/new/client/new/${this.state.searchTerm}`,
      state: { fromVoucher: newPath, isRecipient: true },
    });
    this.setState({ searchTerm: '', recipient: '' });
  };

  searchPurchaser = (event) => {
    if (event.target.value.length > 1) {
      this.setState({
        searchTerm2: event.target.value,
        isDropdownOpen2: true,
        purchaser: '',
      });
      const { clientList } = this.props;
      const purchaserList = clientList.filter((e) => e.user_name.toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0);
      this.setState({ purchaserList });
    } else {
      this.setState({
        searchTerm2: event.target.value,
        purchaser: '',
      });
    }
    if (event.target.value === 'Add new client') {
      this.props.history.push(`${this.props.history.location.pathname}/create/new/client/new/`);
    }
  };

  selectPurchaser = (client) => {
    this.setState({
      searchTerm2: client.user_name,
      voucherObj: { ...this.state.voucherObj, purchased_by_clientId: client.id },
      isDropdownOpen2: false,
    });
  };

  searchStylist = (event) => {
    const searchTerm = event.target.value;
    this.setState({
      searchStylistTerm: searchTerm,
      renderDropdownStylists: searchTerm.length > 1,
    });

    const { stylistList } = this.props;

    const filteredStylists = stylistList.filter((e) => e.status === 'active' && e.has_column && e.user_name.toLowerCase().includes(searchTerm.toLowerCase()));
    this.setState({ stylist: filteredStylists });
  };

  selectStylist = (stylist) => {
    this.setState((prevState) => ({
      searchStylistTerm: stylist.user_name,
      voucherObj: { ...prevState.voucherObj, sold_by_stylistId: stylist.id },
      renderDropdownStylists: false,
    }));
  };

  addNewClient2 = () => {
    let newPath = this.props.location.pathname;
    const pathArray = this.props.history.location.pathname.split('/');
    if (pathArray[3] === 'day') {
      newPath = pathArray.slice(0, 5).join('/');
    } else if (pathArray[3] === 'week') {
      newPath = pathArray.slice(0, 6).join('/');
    }

    this.props.history.push({
      pathname: `${newPath}/create/new/client/new/${this.state.searchTerm2}`,
      state: { fromVoucher: newPath, isPurchaser: true },
    });
    this.setState({ searchTerm2: '', purchaser: '' });
  };

  switchRadio = (targetId) =>
    void this.setState({
      errorSourceMsg: '',
      voucherObj: { ...this.state.voucherObj, source: targetId, amount: this.state.amount },
    });

  handleSubmit = () => {
    const { createVoucher, feBookingCleanUpNewClient, history, posFlow, salonId, setOpenClosePosModal, setVoucher, voucherNumberGenerated, newClient, t } = this.props;
    const { amount, customCode, customMonth, voucherObj, errorInvalidChar } = this.state;

    const voucher = voucherObj || {};
    if (errorInvalidChar) return;

    let error = false;

    if (!amount) {
      this.setState({ errorPrice: t('scheduler.voucherView.voucherValueInputError.noAmount') });
      error = true;
    }

    if (!voucherObj || !voucherObj.source) {
      this.setState({ errorSourceMsg: t('scheduler.voucherView.paymentMethodError') });
      error = true;
    }

    if (error) {
      return;
    }

    const expireDate = moment()
      .add(parseInt(customMonth || DEFAULT_MONTHS_VALUE, 10), 'months')
      .format('YYYY-MM-DD');

    voucher.amount = amount;
    voucher.expires_at = expireDate;

    if (!voucherObj.number && !customCode) {
      voucher.number = voucherNumberGenerated.number;
    } else if (!voucherObj.number && customCode) {
      voucher.number = customCode;
    }

    // adding purchased_by_clientId ID  the new client
    if (newClient && newClient.id) {
      voucher.purchased_by_clientId = newClient.id;
    }

    if (posFlow === true && voucherObj.source === 'card') {
      voucher.source = 'slick_pos';

      setVoucher(voucher);
      setOpenClosePosModal(true);

      this.setState({ voucherObj: voucher });
      return;
    }

    this.setState({ voucherObj: voucher });

    createVoucher(salonId, voucher);
    // request will clear the newClient obj
    feBookingCleanUpNewClient();
    // clear the location.state obj value
    history.replace();
  };

  render() {
    const { calendarMode, onCloseVoucherView, t } = this.props;
    const {
      amount,
      customCode,
      customMonth,
      errorCustomMsg,
      errorMonth,
      errorPrice,
      errorSourceMsg,
      errorInvalidChar,
      isDropdownMonths,
      isDropdownOpen,
      isDropdownOpen2,
      renderDropdownStylists,
      purchaser,
      purchaserList,
      recipient,
      recipientList,
      searchTerm,
      searchTerm2,
      searchStylistTerm,
      value,
      voucherNumberGenerated,
      voucherObj,
      stylist,
    } = this.state;

    const paymentOptions = [
      {
        id: 'cash',
        label: t('scheduler.voucherView.cash'),
        name: 'payment',
        checked: asObject(voucherObj).source === 'cash',
      },
      {
        id: 'card',
        label: t('scheduler.voucherView.card'),
        name: 'payment',
        checked: asObject(voucherObj).source === 'card',
      },
      {
        id: 'other',
        label: t('scheduler.voucherView.other'),
        name: 'payment',
        checked: asObject(voucherObj).source === 'other',
      },
    ];

    const isCompleteSaleDisabled = !amount || !voucherObj?.source || value === ' ' || (value === VOUCHER_CODE_TYPE.custom && (errorCustomMsg || errorInvalidChar || customCode.length <= 0));

    return (
      <div data-bem="VoucherView" id="voucher-view" className="animated slideInRight shadow">
        <section className="voucher-view-container">
          <HeaderWrapper>
            <div data-bem="VoucherView__header" className="voucher-header">
              <h2 className="page-title">{t('scheduler.voucherView.title')}</h2>
              <span className="close-button ico-close" role="button" tabIndex={0} onClick={onCloseVoucherView} />
            </div>
          </HeaderWrapper>

          <BWContent additionalClass="voucher-body">
            <section data-bem="VoucherView__code" className="voucher-code">
              <div className="row radio-group cb-group-code">
                <div className="row-container">
                  <label className="radio-btn" htmlFor="auto-code">
                    <input
                      id={VOUCHER_CODE_TYPE.auto}
                      value={VOUCHER_CODE_TYPE.auto}
                      name={VOUCHER_CODE_TYPE.auto}
                      type="radio"
                      checked={value === VOUCHER_CODE_TYPE.auto}
                      onChange={this.onChangeRadioCode}
                    />
                    <span className="checkmark" />
                    <div className="radio-text">{t('scheduler.voucherView.autoGeneratedCodeCheckbox')}</div>
                  </label>
                  <input readOnly disabled id="auto-generated-code" value={!customCode ? voucherNumberGenerated : ''} type="text" />
                </div>
                <div className="row-container">
                  <label className="radio-btn" htmlFor="custom-code">
                    <input
                      id={VOUCHER_CODE_TYPE.custom}
                      value={VOUCHER_CODE_TYPE.custom}
                      name={VOUCHER_CODE_TYPE.custom}
                      type="radio"
                      checked={value === VOUCHER_CODE_TYPE.custom}
                      onChange={this.onChangeRadioCode}
                    />
                    <span className="checkmark" />
                    <div className="radio-text">{t('scheduler.voucherView.manualCodeCheckbox')}</div>
                  </label>
                  <input
                    id="custom-code-input"
                    type="text"
                    value={customCode}
                    onChange={this.onChangeCustomCode}
                    onFocus={this.onBlurCustomCode}
                    onBlur={this.onBlurCustomCode}
                    ref={this.customCodeRef}
                  />
                </div>

                {errorInvalidChar && (
                  <div className={CN.alertOuter}>
                    <AlertPanel tag="AlertPanel__custom-code" variant="warningPanel" variantInvert>
                      <Icon variant="warning" />
                      <div className={CN.customCodeAlert}>
                        {t('scheduler.voucherView.manualCodeInputAlertMsg.part1')} {S.quoteOpen}
                        {S.amp}
                        {S.quoteClose} {t('scheduler.voucherView.manualCodeInputAlertMsg.part2')}
                      </div>
                    </AlertPanel>
                  </div>
                )}

                {value === VOUCHER_CODE_TYPE.auto ? (
                  <div />
                ) : (
                  <div>
                    {value === VOUCHER_CODE_TYPE.custom && customCode.length <= 0 ? (
                      <span className="error">{t('scheduler.voucherView.inputValidationError.enterCode')}</span>
                    ) : (
                      <>{errorCustomMsg ? <span className="error">{t('scheduler.voucherView.inputValidationError.issuedCode')}</span> : <div />}</>
                    )}
                  </div>
                )}
              </div>
            </section>
            <div className="divider addition" />
            <section className="voucher-settings">
              <div className="v-value">
                <span className="text">{t('scheduler.voucherView.voucherValueLabel')}</span>
                <span>
                  <CurrencySign />
                </span>
                <input type="text" value={amount} onChange={this.validateVoucherPrice} onBlur={this.validatePriceOnBlur} />
                <span className="error">{errorPrice}</span>
              </div>

              <div className="v-sxp-time">
                <span className="text">{t('scheduler.voucherView.expiresAfterLabel')}</span>

                <div className="dropdown-container" onBlur={this.onMonthBlur} tabIndex={-1}>
                  <input
                    type="text"
                    placeholder=" "
                    className="dropdown-search dropdown--month"
                    value={customMonth || DEFAULT_MONTHS_VALUE}
                    onChange={this.onChangeMonth}
                    onFocus={this.onChangeMonth}
                    onBlur={this.validateMonthOnBlur}
                    autoComplete="off"
                  />

                  {isDropdownMonths && (
                    <div className="dropdown-suggestions" style={{ zIndex: '3' }}>
                      {MONTHS.map((month) => (
                        <div className="item" key={month.value} onClick={() => this.onSelectMonth(month.value)} role="menuitem" tabIndex="0">
                          <span>{month.value}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <span className="">{t('scheduler.voucherView.months')}</span>
                <span className="error">{errorMonth}</span>
              </div>
            </section>
            <div className="divider addition" />
            <section className="client-search">
              <div className="v-recipient">
                <span className="text">{t('scheduler.voucherView.voucherRecipientLabel')}</span>

                <VoucherViewDropdown onBlur={this.onRecipientBlur}>
                  <VoucherViewDropdown.Input onChange={this.searchRecipient} placeholder={t('scheduler.voucherView.voucherRecipientPlaceholder')} value={recipient || searchTerm} />
                  {isDropdownOpen && (
                    <VoucherViewDropdown.Options
                      showButton
                      calendarMode={calendarMode}
                      onClick={this.addNewClient}
                      onSelect={this.selectRecipient}
                      options={recipientList.map((item) => ({ ...item, value: item.user_name }))}
                    />
                  )}
                </VoucherViewDropdown>
              </div>
              <div className="v-purchased-by">
                <span className="text">{t('scheduler.voucherView.purchasedByLabel')}</span>

                <VoucherViewDropdown onBlur={this.onPurchaserBlur}>
                  <VoucherViewDropdown.Input onChange={this.searchPurchaser} placeholder={t('scheduler.voucherView.voucherRecipientPlaceholder')} value={purchaser || searchTerm2} />
                  {isDropdownOpen2 && (
                    <VoucherViewDropdown.Options
                      showButton
                      calendarMode={calendarMode}
                      onClick={this.addNewClient2}
                      onSelect={this.selectPurchaser}
                      options={purchaserList.map((item) => ({ ...item, value: item.user_name }))}
                    />
                  )}
                </VoucherViewDropdown>
              </div>
            </section>

            <div className="v-purchased-by sold-by">
              <span className="text">{t('scheduler.voucherView.soldByLabel')}</span>

              <VoucherViewDropdown onBlur={alwaysNoop}>
                <VoucherViewDropdown.Input onChange={this.searchStylist} placeholder={t('scheduler.voucherView.soldByPlaceholder')} value={searchStylistTerm} />
                {renderDropdownStylists && (
                  <VoucherViewDropdown.Options
                    showButton={false}
                    calendarMode={calendarMode}
                    onClick={alwaysNoop}
                    onSelect={this.selectStylist}
                    options={stylist.map((item) => ({ ...item, value: item.user_name }))}
                  />
                )}
              </VoucherViewDropdown>
            </div>

            <div className="divider addition" />
            <section className="form cfix cash-or-card">
              <small>{t('scheduler.voucherView.paymentMethodSectionTitle')}</small>
              <div className="row radio-group cb-group-payment">
                <RadioForm
                  selections={paymentOptions}
                  onChange={(e) => {
                    const sourceValue = e ? e.target.id : '';
                    this.switchRadio(sourceValue);
                  }}
                />
              </div>
            </section>
          </BWContent>
        </section>
        <div className="voucher-footer">
          <div>
            {this.props.isFetching ? (
              <div className="spinner-container-in-voucher">
                <div className="load-spinner" />
              </div>
            ) : (
              <button className="btn btn-violet" onClick={this.handleSubmit} disabled={isCompleteSaleDisabled}>
                {t('scheduler.voucherView.completeButton')}
              </button>
            )}

            {errorSourceMsg !== '' && <span className="error">{errorSourceMsg}</span>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { booking } = state;
  const { errorMessage, isFetching, voucherCreated, voucherList, voucherNumberGenerated } = selectCashup(state);
  return {
    calendarMode: selectCurrentSalonCalendarMode(state),
    clientList: selectCurrentSalonClientsArray(state),
    stylistList: selectCurrentSalonStylists(state),
    errorMessage,
    isFetching,
    newClient: booking.newClient.response,
    posFlow: selectCurrentSalonPosFlow(state),
    salonId: selectCurrentSalonId(state),
    voucherCreated,
    voucherList,
    voucherNumberGenerated,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkVoucher,
      createVoucher,
      feBookingCleanUpNewClient,
      generateVoucherNumber,
      getAllVoucher,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VoucherView)));
